import { render, staticRenderFns } from "./AreaChart.vue?vue&type=template&id=61c0921d"
import script from "./AreaChart.vue?vue&type=script&lang=js"
export * from "./AreaChart.vue?vue&type=script&lang=js"
import style0 from "./AreaChart.vue?vue&type=style&index=0&id=61c0921d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports